import { DownOutlined, FolderOpenTwoTone, LoadingOutlined, SaveOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Col, Row, Spin, Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { Tabs } from 'antd/lib';
import { Key, useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { PhanChucNangRequest } from '../../models/chucnang/ChucNang';
import SearchAccountTable from '../../modules/department/SearchAccountTable';
import { layDSChucNangRiengTheoIdNguoiDung, layDanhSachChucNangTreeView, layDsChucNangDiKemQuyen, luuDsChucNangRieng } from '../../services/chucnang';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const convertDataTreeView = (data: any, featuresOfRule: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: _item?.id,
                title: _item?.tenChucNang,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                disabled: featuresOfRule.filter((x: any) => x.id === _item?.id).length > 0,
                children: convertDataTreeView(_item?.children, featuresOfRule)
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const convertDataTreeViewNguoiDung = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data && data != null) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.tenDangNhap == null ? _item?.id.toString() + "_" + _item?.ten : _item?.id,
                title: _item?.ten || _item?.hoTen,
                icon: _item?.tenDangNhap == null ? <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" /> : <UserOutlined style={{ fontSize: "20px", color: "#4096ff" }} rev="" />,
                children: convertDataTreeViewNguoiDung(_item?.children)
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;
const PhanChucNang = () => {
    const [canSave, setCanSave] = useState(false);
    const [openModalSave, setOpenModalSave] = useState<boolean>(false);
    const [idNguoiDung, setIdNguoiDung] = useState<number>(0);
    const [chucNangSelected, setChucNangSelected] = useState<number>(0);
    const [checkedKeys, setCheckedKeys] = useState<Array<number>>([]);
    const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);
    const [expandedKeys, setExpandedKeys] = useState<Array<number>>([]);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const [treeDataQuanTri, setTreeDataQuanTri] = useState<Array<DataNode>>([]);
    const [treeDataND, setTreeDataND] = useState<Array<DataNode>>([]);
    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [loadingNguoiDung, setLoadingNguoiDung] = useState<boolean>(false);
    const [listAdminId, setListAdminId] = useState<Array<number>>([]);
    const [listChucNangIdTheoQuyen, setListChucNangIdTheoQuyen] = useState<Array<number>>([]);
    const [reloadTree, setReloadTree] = useState<boolean>(true);

    const [features, setFeatures] = useState<any>([]);
    const [accountSelected, setAccountSelected] = useState<any>();
    const [featuresForRule, setFeaturesForRule] = useState<any>([]);

    const [selectedFeatureIds, setSelectedFeatureIds] = useState<Array<any>>([]);

    const dispatch = useDispatch();

    const disableNodes = (data: any, keysToDisable: any) => {
        return data.map((node: any) => {
            const disabled = keysToDisable.includes(node.key);
            if (node.children) {
                return { ...node, children: disableNodes(node.children, keysToDisable), disabled };
            }
            return { ...node, disabled };
        });
    };

    const enableAllNodes = (data: any) => {
        return data.map((node: any) => {
            const disabled = false;
            if (node.children) {
                return { ...node, children: enableAllNodes(node.children), disabled };
            }
            return { ...node };
        });
    };
    const onSelect = async (selectedKeys: Key[], info: any) => {
        setLoadingTree(true);
        if (selectedKeys.length != 0 && (typeof selectedKeys[0] == 'number')) {
            setCanSave(true);
            let id = selectedKeys[0] as number;
            setChucNangSelected(id)
            setIdNguoiDung(id);
            if (!listAdminId.includes(id)) {
                let rs = await layDSChucNangRiengTheoIdNguoiDung(id);
                let tempArray: Array<number> = [];
                let tempArrayCNTheoQuyen: Array<number> = [];
                rs.forEach((item) => {
                    tempArray.push(item.id as number)
                });
                var chucNangTheoQuyen = await layDsChucNangDiKemQuyen(id);
                chucNangTheoQuyen.forEach((item) => {
                    tempArrayCNTheoQuyen.push(item.id as number)
                });
                setListChucNangIdTheoQuyen(tempArrayCNTheoQuyen);
                var expandedTemp: Array<number> = [];
                let data = [...rs, ...chucNangTheoQuyen];
                data.forEach((item) => {
                    if (item.idCha != null || item.idCha != 0) {
                        expandedTemp.push(item.idCha)
                    };
                })
                var expanded = Array.from(new Set(expandedTemp));
                setExpandedKeys(expanded);
                var tempChecked = Array.from(new Set([...tempArray, ...tempArrayCNTheoQuyen]));
                setCheckedKeys(tempChecked);
                let updatedTreeData = disableNodes(treeData, tempArrayCNTheoQuyen);
                setTreeData(updatedTreeData);
                setLoadingTree(false);
            }
            setLoadingTree(false)
        }
        else {
            setCanSave(false);
            setChucNangSelected(0);
            setTreeData(enableAllNodes(treeData));
            setLoadingTree(false)
        }
    };
    const onSave = async () => {
        dispatch(showLoadingScreen());
        var list = [];
        for (var i = 0; i < selectedFeatureIds.length; i++) {
            if (!featuresForRule.find((x: any) => x.id === selectedFeatureIds[i])) {
                list.push(selectedFeatureIds[i]);
            }
        }

        var request: PhanChucNangRequest = {
            idNguoiDung: accountSelected.id,
            chucNang: list
        }

        var rs = await luuDsChucNangRieng(request);
        if (rs) {
            toast.success('Cập nhật chức năng cho người dùng thành công')
        }
        else {
            toast.error('Cập nhật chức năng cho người dùng không thành công')
        }

        dispatch(hideLoadingScreen());
    }
    const onExpand = (expandedKeysValue: any) => {
        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };
    const onCheckTree = (checkedKeysValue: any) => {
        setSelectedFeatureIds(checkedKeysValue.checked || []);
    };
    const getLeafKeys = (inputList: Array<DataNode>) => {
        let leafKeys: Array<number> = [];
        inputList.forEach((node) => {
            if (node.children && node.children.length > 0) {
                const childLeafNodes = getLeafKeys(node.children);
                leafKeys.push(...childLeafNodes);
            } else {
                leafKeys.push(node.key as number);
            }
        });
        return leafKeys;
    }

    const laydsChucNang = async () => {
        try {
            setLoadingTree(true);
            let data = await layDanhSachChucNangTreeView();
            setFeatures(data);
        } catch (error: any) {
            toast.error(error);
        };
        setLoadingTree(false);
    }
    //const laydsNguoiDung = async () => {
    //    try {
    //        setLoadingNguoiDung(true);
    //        let data2 = await layDsToanBoDonVi();
    //        let tempDonViId: Array<number> = [];
    //        let listTempId: Array<number> = []
    //        const promises = data2.map(async (item) => {
    //            tempDonViId.push(item.id);
    //            //let dsNguoiDungCuaDonVi = await layDSNguoiDungTheoIdDonVi(item.id as number, 0, 1000);
    //            let dsNguoiDungCuaDonVi = {};
    //            var temp = dsNguoiDungCuaDonVi.data.filter((item) => item['id'] != 0);
    //            var tempAdminId = dsNguoiDungCuaDonVi.data.filter((item) => item['isAdmin']);
    //            tempAdminId.map((item) => {
    //                listTempId.push(item['id']);
    //            });
    //            item.children = temp;
    //        });
    //        await Promise.all(promises);
    //        setListAdminId(listTempId);
    //        setTreeDataND(convertDataTreeViewNguoiDung(data2));
    //        setLoadingNguoiDung(false);
    //    } catch (error: any) {
    //        setLoadingNguoiDung(false);
    //    };
    //}

    const onSelectAccount = (account: any) => {
        setAccountSelected(account);
    }

    const loadFeaturesOfAccount = async () => {
        if (!accountSelected?.key) {
            setFeaturesForRule([]);
            setSelectedFeatureIds([]);
            return;
        }

        setLoadingTree(true);
        try {
            let fOU = await layDSChucNangRiengTheoIdNguoiDung(accountSelected.id);
            let fBR = await layDsChucNangDiKemQuyen(accountSelected.id);
            const selectedFeatureIds = [...fOU.map(x => x.id), ...fBR.map(x => x.id)];
            setFeaturesForRule(fBR);
            setSelectedFeatureIds(selectedFeatureIds);
        } catch (ex: any) {
            toast.error(ex);
        }

        setLoadingTree(false);
    }

    useEffect(() => {
        const featureTree = convertDataTreeView(features, featuresForRule);
        setTreeData(featureTree);
    }, [featuresForRule, features]);

    useEffect(() => {
        loadFeaturesOfAccount();
    }, [accountSelected]);

    useEffect(() => {
        laydsChucNang();
    }, []);

    return (<section>
        {/*<Modal show={openModalSave} onHide={() => setOpenModalSave(false)}>*/}
        {/*    <Modal.Header closeButton>*/}
        {/*        <Modal.Title>Phân chức năng cho người dùng</Modal.Title>*/}
        {/*    </Modal.Header>*/}
        {/*    <Modal.Body>*/}
        {/*        Bạn có muốn cập nhật danh sách chức năng không?*/}
        {/*    </Modal.Body>*/}
        {/*    <Modal.Footer style={{*/}
        {/*        "display": "flex",*/}
        {/*        "justifyContent": "space-between"*/}
        {/*    }}>*/}
        {/*        <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalSave(false)}>*/}
        {/*            Đóng*/}
        {/*        </Button>*/}
        {/*        <Button variant="primary" className="btn-sm" onClick={() => onSave()}>*/}
        {/*            Xác nhận*/}
        {/*        </Button>*/}
        {/*    </Modal.Footer>*/}
        {/*</Modal>*/}
        <ModalTextForm
            show={openModalSave}
            title="Phân chức năng cho người dùng"
            handleClose={() => setOpenModalSave(false)}
            handleSave={async () => {
                await onSave()
                setOpenModalSave(false)
            }}
        >
            <p>Bạn có xác nhận lưu chức năng cho người dùng này không?</p>
        </ModalTextForm>
        <ContentHeader title="Phân chức năng" />
        <Row gutter={16}>
            <Col span={16}>
                <SearchAccountTable onChange={onSelectAccount} />
            </Col>
            <Col span={8}>
                <Tabs defaultActiveKey="1"
                    tabBarExtraContent=
                    {
                        accountSelected?.id ?
                        <Button
                            type="primary"
                            icon={<SaveOutlined rev="" />}
                            onClick={() => setOpenModalSave(true)}
                        > Lưu
                        </Button> : <></>
                    }
                    items={[{
                        key: '1',
                        label: 'Danh sách chức năng',
                        children:
                            <div className="card card-body">
                                <Row>
                                    <Col span="24">
                                        {loadingTree ?
                                            <Spin indicator={antIcon} />
                                            : <div id="treeView">
                                                <Tree
                                                    checkable={accountSelected?.key ? true : false}
                                                    checkedKeys={selectedFeatureIds || []}
                                                    showIcon
                                                    showLine
                                                    multiple
                                                    switcherIcon={<DownOutlined rev="" />}
                                                    treeData={treeData}
                                                    onCheck={onCheckTree}
                                                    autoExpandParent
                                                    blockNode
                                                    checkStrictly
                                                    defaultExpandParent
                                                />
                                            </div>
                                        }
                                    </Col>
                                </Row>
                            </div>
                    }
                    ]}
                >
                </Tabs>
                {/*<div className="card card-primary card-outline">*/}
                {/*    <div className="card-header">*/}
                {/*        <h3 className="card-title">Danh sách chức năng</h3>*/}
                {/*        <div className="float-right card-tools">*/}
                {/*            {canSave ? !listAdminId.includes(idNguoiDung) ? <Button className="btn btn-success btn-sm pull-right" type="button" onClick={() => setOpenModalSave(true)} title="Lưu" ><i className="fa fa-save" /></Button> : null : null}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <div className="card-body">*/}
                {/*        <Row>*/}
                {/*            <Col span="24">*/}
                {/*                {loadingTree ?*/}
                {/*                    <Spin indicator={antIcon} />*/}
                {/*                    : <div id="treeView">*/}
                {/*                        <Tree*/}
                {/*                            checkable={accountSelected?.key ? true : false}*/}
                {/*                            checkedKeys={selectedFeatureIds || []}*/}
                {/*                            showIcon*/}
                {/*                            showLine*/}
                {/*                            multiple*/}
                {/*                            switcherIcon={<DownOutlined rev="" />}*/}
                {/*                            treeData={treeData}*/}
                {/*                            onCheck={onCheckTree}*/}
                {/*                            autoExpandParent*/}
                {/*                            blockNode*/}
                {/*                            checkStrictly*/}
                {/*                            defaultExpandParent*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*                }*/}
                {/*            </Col>*/}
                {/*        </Row>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </Col>
        </Row>
    </section>
    );
};

export default PhanChucNang;
